import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import SimpleHeader from './SimpleHeader';
import SimpleSidebar from './SimpleSidebar';

interface LayoutProps {
  children: ReactNode;
  showSidebar?: boolean;
}

const SimpleLayout: React.FC<LayoutProps> = ({ 
  children, 
  showSidebar = true 
}) => {
  const location = useLocation();
  const isStatisticsPage = location.pathname === '/statistics';
  const isUsersPage = location.pathname === '/users';
  const isFullWidthPage = isStatisticsPage || isUsersPage;

  return (
    <div style={{ 
      display: 'flex', 
      height: '100vh', 
      background: '#ffffff',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", sans-serif'
    }}>
      {/* Sidebar - скрывается на экранах < 768px */}
      {showSidebar && !isFullWidthPage && (
        <div style={{
          display: window.innerWidth < 768 ? 'none' : 'block'
        }}>
          <SimpleSidebar />
        </div>
      )}
      <main style={{ 
        flex: 1, 
        display: 'flex', 
        flexDirection: 'column', 
        overflow: 'hidden',
        minWidth: 0,
        width: '100%'
      }}>
        <SimpleHeader />
        <div style={{
          flex: 1,
          overflowY: 'auto',
          padding: isFullWidthPage ? '0' : window.innerWidth < 768 ? '0.75rem' : '1.5rem',
          background: isFullWidthPage ? '#f9fafb' : '#ffffff'
        }}>
          {children}
        </div>
      </main>
    </div>
  );
};

export default SimpleLayout;
